import { Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { APIS } from 'src/lib/constants/apis';
import { FormStrucItem } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import schemas
import Schema from 'src/lib/paths/person_FULL_Paths.json';
const P = Schema.attributes;

const PersonDaten: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	personDatenError: any;
}> = ({ formValue, updateFunction, personDatenError }) => {
	return (
		<>
			<ApplicationHeading title={'Ihr Profil '} />
			<Stack spacing={2} mb={2}>
				<Typography variant='body1'>
					Bitte füllen Sie die Daten in Ihrem Profil vollständig aus.{' '}
					<strong>Der Registrierungslink für Ihre Anmeldung hier im Portal wird an die hier angegebene E-Mail-Adresse versendet.</strong>
				</Typography>
			</Stack>

			<CreateForm
				formValues={formValue}
				formStruc={formStruc()}
				updateFormValuesFunc={updateFunction}
				formErrors={personDatenError}
				api={APIS.Person}
			/>
		</>
	);
};

export default PersonDaten;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Personenbezogene_Daten_Anrede, P.Personenbezogene_Daten_Titel],
		},
		{
			fields: [P.Personenbezogene_Daten_Vorname, P.Personenbezogene_Daten_Nachname],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Kontaktdaten_E_Mail, P.Kontaktdaten_Telefon],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};
